<template>
	<div class="content">
		<transition name="fade">
			<!-- && hallItem.isCover -->
			<div v-show="coverShow" class="cover">
				<!-- <div v-show="true" class="cover"> -->
				<div v-if="!isMobile()" class="pc" ref='pc'>
					<!-- <div class="bg-image" :style="{backgroundImage: 'url(' + coverUrl + '?v='+ date + ')' } "></div> -->
					<img ref="cImage" class="bg-image" :src="coverUrl + '?v='+ date " alt="">
					<div class="countdown-div" ref="countdownDiv" @click="coverButtonTap()">
						<span v-text="countDown+' 秒'"></span>
					</div>
					<div class="enter-watch-button" @click="coverButtonTap()">
					</div>
				</div>

				<div v-else class="moblie" ref='moblie'>
					<img ref="cImage" class="bg-image" v-bind:src="coverUrl + '?v='+ date " />
					<div class="countdown-div" ref="countdownDiv">
						<span v-text="countDown+' 秒'" @click="coverButtonTap()"></span>
					</div>
					<div class="enter-watch-button" @click="coverButtonTap()"></div>
				</div>

			</div>
		</transition>
		<!-- 滚动字幕 -->
		<div class="marqueePC" v-if=" showMarquee &&!isMobile() && hallItem.isRoll == '1' ? true : false  ">
			<marquee behavior="scroll" direction="left"><span style="font-size: 16px; color: #eee;">{{hallItem.roll}}</span></marquee>
		</div>
		<div class="marqueeMoblie" v-if="showMarquee && isMobile() && hallItem.isRoll == '1' ? true : false">
			<marquee behavior="scroll" direction="left"><span style="font-size: 14px; color: #eee;">{{hallItem.roll}}</span></marquee>
		</div>
		<div class="login" v-if="false">
			<el-button type="info" icon="el-icon-user" circle style="width: 45px; height: 45px;" @click="weChatLogin">
			</el-button>

		</div>
		<div id="pano" ref="pano"></div>
		<div class="views" v-show="hallItem.isViews == '1'&& showViews">观看量：{{hallItem.views}}</div>
		<div class="photo-galley">
			<ul id="galley">
				<li v-for="item in pictureList">
					<img :data-original="item.picturePath+'?x-oss-process=image/resize,w_1200,limit_0'" :src="item.picturePath+'?x-oss-process=image/resize,w_50,limit_0'"
					 :alt="item.pictureTitle">
				</li>
			</ul>
			<ul v-for="item in hotSpotPictureList" :id="'galley_'+item.hotId">
				<li v-for="subItem in item.hotPictureDOList">
					<img :data-original="subItem.picturePath+'?x-oss-process=image/resize,w_1200,limit_0'" :src="subItem.picturePath+'?x-oss-process=image/resize,w_50,limit_0'">
				</li>
			</ul>
		</div>
		<div v-wechat-title="$route.meta.title=hallItem.title"></div>
	</div>
</template>

<script>
	import wx from 'weixin-js-sdk'
	import wxapi from '@/common/wxapi.js'
	import {
		Decrypt,
		Encrypt
	} from '@/common/secret.js'
	export default {
		name: "",
		components: {},
		data() {
			return {
				hallId: "-1",
				title: "",
				des: "",
				shareImageUrl: "",
				pictureList: [],
				hotSpotPictureList: [],
				countDown: 5,
				coverShow: false,
				coverUrl: "",
				xmlUrl: "",
				hallItem: {},
				showMarquee: false,
				showViews: true,
				date: '',
				timer: null, //巡游定时器
				timeCount: 1, //当前巡游到第几张

			};
		},
		watch: {
			'coverShow'(newVal, oldVal) {


				if (newVal == false) {
					console.log('在watch时刷新krpano')
					this.renderPano(this.xmlUrl);
					this.showMarquee = true
					let _this = this
					setTimeout(function() {
						// 得到场景列表后，开启巡游
						_this.changeScene('first')
						// 为鼠标按下后拖拽事件
						_this.bindMethod()
					}, 3000)
				}

			}
		},
		metaInfo() {
			return {
				title: this.title,
				meta: [{
						charset: "utf-8"
					},
					{
						name: "viewport",
						content: "width=device-width,height=device-height, initial-scale=1, maximum-scale=1, user-scalable=0"
					},
					{
						name: "title",
						property: "og:title",
						content: this.title
					},
					{
						name: "description",
						property: "og:description",
						content: this.des
					},
					{
						name: "imageurl",
						property: "og:image",
						content: this.shareImageUrl
					}
				]
			};
		},
		computed: {},
		created() {

		},
		mounted() {
			// this.testWeChat()
			this.date = new Date().getTime()
			this.changeShowViews()
			// this.$global.SERVER_OFFLINE为true就是离线版本
			if (!this.$global.SERVER_OFFLINE) {
				this.hallId = Decrypt(this.$route.query.roomId);
				this.$store.commit("updataHallId", Decrypt(this.$route.query.roomId))
				this.intoWatch(this.hallId)
			}

			this.infoDataRequest();
			this.initPictureList(this.hallId);
			this.initHotspotPictureList(this.hallId);

			// window.addEventListener("resize", this.renderPano(this.xmlUrl), false)

		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			testWeChat() {
				let path = "/api/phone/callBack";
				let payload = {
					params: {
						code: 'code',
						roomId: this.$store.state.hallId,
						entrance: 'PC'
					}
				}
				this.$global.axios
					.get(path, payload)
					.then(res => {
						if (res.data.success) {
							console.log(res)
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			isMobile() {
				return navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				);
				return true;
			},
			isWeixn() {
				var ua = navigator.userAgent.toLowerCase();

				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return true;
				} else {
					return false;
				}
			},
			infoDataRequest() {
				let payload = {
					params: {
						roomId: this.hallId,
					}
				};
				let path = ''
				if (!this.$global.SERVER_OFFLINE) {
					path = "/api/cloudget/xml"
				} else {
					path = this.$global.SERVER_SUBFILE + "json/xml.json"
				}


				this.$global.axios
					.get(path, payload)
					.then(res => {
						if (res.data.success) {
							console.log(res.data)
							document.title = res.data.data.title
							// wx.getSetting({
							//   success (res) {
							//     console.log(res.authSetting)
							//     // res.authSetting = {
							//     //   "scope.userInfo": true,
							//     //   "scope.userLocation": true
							//     // }
							//   }
							// })
							this.hallItem = res.data.data
							wxapi.wxRegister(this.wxRegCallback) //微信分享相关操作
							// 判断当前展厅的观看权限
							// alert(this.hallItem.lookStatus == '1' && this.isWeixn() && this.$store.state.wxUser == null)
							console.log(this.hallItem.lookStatus == '1' && this.isWeixn() && this.$store.state.wxUser == null)
							if (this.hallItem.lookStatus == '1' && this.isWeixn() && this.$store.state.wxUser == null && this.isMobile()) {

								this.weChatLogin()

							}

							// 在查询出结果之后，发送微信分享的请求
							if (this.isMobile()) {
								this.coverUrl = res.data.data.coverMobile;
								// 判断 isColor 存在 并判断是否为1，若为1 则
								if (res.data.data.isColor && res.data.data.isColor == '1') {
									// 开启背景色
									this.$refs.moblie.style.setProperty("--background", res.data.data.color)
									this.$refs.moblie.style.setProperty("--filter", 'none')

								} else if ( !res.data.data.isColor || res.data.data.isColor == '0') {
									// 使用高斯模糊
									if(this.$global.SERVER_OFFLINE) {
										// 是用相对路径会出问题，会从css文件中找picture文件夹
										this.$refs.moblie.style.setProperty("--background", 'transparent url(../' + this.coverUrl + ')  no-repeat')
									}else {
										this.$refs.moblie.style.setProperty("--background", 'transparent url(' + this.coverUrl + ')  no-repeat')
									}
								}

							} else {
								console.log(res.data.data.coverPc)
								this.coverUrl = res.data.data.coverPc;
								if (res.data.data.isColor && res.data.data.isColor == '1') {
									this.$refs.pc.style.setProperty("--background",  res.data.data.color)
									this.$refs.pc.style.setProperty("--filter", 'none')
								} else if ( !res.data.data.isColor || res.data.data.isColor == '0') {
									if(this.$global.SERVER_OFFLINE) {
										// 是用相对路径会出问题，会从css文件中找picture文件夹
										this.$refs.pc.style.setProperty("--background", 'transparent url(../' + this.coverUrl + ')  no-repeat')
									}else {
										this.$refs.pc.style.setProperty("--background", 'transparent url(' + this.coverUrl + ')  no-repeat')
									}
								}
								// this.$refs.pc.style.setProperty("--background", 'transparent url(' + this.coverUrl + ')  no-repeat')
							}
							// ------------------------
							console.log(this.coverUrl)
							this.getImgWH()
							// -----------------
							this.xmlUrl = res.data.data.xml
							console.log(this.xmlUrl)
							if (!this.hallItem.isCover || this.hallItem.isCover == '0') {
								console.log('？？？这里会执行')
								this.coverShow = false
								this.renderPano(this.xmlUrl);
								this.showMarquee = true
								let _this = this
								setTimeout(function() {
									// 得到场景列表后，开启巡游
									_this.changeScene('first')
									// 为鼠标按下后拖拽事件
									_this.bindMethod()
								}, 3000)
								// this.renderPano(this.xmlUrl);
							} else {
								/** 初始化方法  **/
								this.coverShow = true
								this.$nextTick(function() {
									this.hideCover();
								});
							}
						} else {
							console.log("数据获取失败" + res.data.msg);
							this.$message.error(res.data.msg);
						}
					})
					.catch(err => {
						console.log("数据获取失败" + err);
					});
			},

			renderPano(xmlUrl) {
				// 查询场景分组表
				// 渲染全景图
				console.log('生成krpano')
				var jsUrl = ''
				if (this.$global.SERVER_OFFLINE) {
					jsUrl = this.$global.SERVER_SUBFILE + 'js/tour.js'
				} else {
					jsUrl = '/js/tour.js'
				}
				var tourXmlUrl = xmlUrl + "?v=" + String((new Date()).valueOf());;
				var tourSwfUrl = xmlUrl + "?v=" + String((new Date()).valueOf());;
				var _doc = document.getElementsByTagName('head')[0];
				var js = document.createElement('script');
				js.setAttribute('type', 'text/javascript');
				js.setAttribute('src', jsUrl); // jsUrl是JS文件的路径
				_doc.appendChild(js);

				// 下面是加载全景图, 针对不同浏览器做兼容
				if (document.all) { //如果是IE
					js.onreadystatechange = function() {
						if (js.readyState == 'loaded' || js.readyState == 'complete') {
							console.log(tourXmlUrl)
							embedpano({ // js插件中的方法，用于加载全景图
								swf: tourSwfUrl,
								xml: tourXmlUrl,
								target: "pano",
								html5: "always",
								mobilescale: 1.0,
								passQueryParameters: true
							});
							this.krpano = document.getElementById("krpanoSWFObject");

							// this.krpano
							// var fov = Number( krpano.get("view.fov") );

						}
					}
				} else {
					js.onload = function() {
						embedpano({
							swf: tourSwfUrl, // krpano全景图的swf文件路径
							xml: tourXmlUrl, // krpano全景图的xml文件路径
							target: "pano",
							html5: "auto",
							mobilescale: 1.0,
							flash: 'auto',
							passQueryParameters: true
						});
						this.krpano = document.getElementById("krpanoSWFObject");
					}
				}
			},
			getImgWH() {
				let _this = this
				console.log(this.$refs.cImage.style.width)
				let img = new Image()
				img.src = this.coverUrl
				img.onload = function() {
					console.log('图片原始高度', img.height)
					console.log('图片原始宽度', img.width)
					console.log('屏幕宽度', document.body.offsetWidth)
					console.log('高度', document.body.offsetHeight)
					if (img.width < document.body.offsetWidth && img.height > document.body.offsetHeight) {
						_this.$refs.cImage.style.height = document.body.offsetHeight + 'px'
						// _this.$refs.cImage.style.width = document.body.offsetWidth + 'px'
						console.log('宽1',_this.$refs.cImage.style.width)
						console.log('高1',_this.$refs.cImage.style.height)
					}else
					if (img.height < document.body.offsetHeight && img.width > document.body.offsetWidth) {
						_this.$refs.cImage.style.height = document.body.offsetHeight + 'px'
						// _this.$refs.cImage.style.width = document.body.offsetWidth + 'px'
						console.log('宽2',_this.$refs.cImage.style.width)
						console.log('高2',_this.$refs.cImage.style.height)
					}else if(img.height < document.body.offsetHeight && img.width < document.body.offsetWidth) {
						// _this.$refs.cImage.style.width = document.body.offsetWidth + 'px'
						// _this.$refs.cImage.style.height = document.body.offsetHeight + 'px'
						console.log('宽3',_this.$refs.cImage.style.width)
						console.log('高3',_this.$refs.cImage.style.height)
					}else if(img.height > document.body.offsetHeight && img.width > document.body.offsetWidth) {
						_this.$refs.cImage.style.width = document.body.offsetWidth + 'px'
						console.log('宽4',_this.$refs.cImage.style.width)
						console.log('高4',_this.$refs.cImage.style.height)
					}
					
				}
			},
			initPictureList(roomId) {
				// 图片集
				let path = ''
				if (!this.$global.SERVER_OFFLINE) {
					path = '/api/cloudget/pictureList'
				} else {
					path = this.$global.SERVER_SUBFILE + 'json/pictureList01.json'
				}

				let params = {
					params: {
						roomId: roomId,
						offset: 0,
						limit: 999
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							// console.log(res.data.data.rows)
							this.pictureList = res.data.data.rows
						} else {
							this.$message.error('失败' + res.data.msg)
						}
					})
			},
			initHotspotPictureList(roomId) {
				// 图片集
				let path = ''
				if (!this.$global.SERVER_OFFLINE) {
					path = '/api/cloudget/allpicture'
				} else {
					path = this.$global.SERVER_SUBFILE + 'json/allpicture.json'
				}

				let params = {
					params: {
						roomId: roomId,
						offset: 0,
						limit: 999
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							this.hotSpotPictureList = res.data.data;
						} else {
							this.$message.error('失败' + res.data.msg)
						}
					})
			},
			intoWatch(roomId) {
				// 进入展厅观看页是调用该方法
				let path = '/api/counts/login'
				let params = {
					params: {
						roomId: roomId,
						// 暂时不传如观看者id
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							// console.log('进入计数成功')
						} else {
							this.$message.error('计数方法调用失败' + res.data.msg)
						}
					})
			},
			// outWatch() {
			// 	// 离开展厅观看页后调用该方法
			// 	let path = '/api/counts/exit'
			// 	let params = {
			// 		params: {
			// 			roomId: roomId,
			// 			// 暂时不传如观看者id
			// 		}
			// 	}
			// 	this.$global.axios
			// 		.get(path, params)
			// 		.then(res => {
			// 			if (res.data.success) {
			// 				console.log('离开计数成功')
			// 			} else {
			// 				this.$message.error('计数方法调用失败' + res.data.msg)
			// 			}
			// 		})
			// },
			changeShowViews() { //显示或隐藏观看量
				this.showViews = !this.showViews
			},
			coverButtonTap() {
				this.coverShow = false;

			},
			changeScene(times = 'notFirst') {

				if (this.hallItem.isCruising == '1') {

					// this.timeCount = 1
					let _this = this

					this.timer = setInterval(function() {
						if (_this.timeCount == _this.hallItem.sceneIds.length) {
							_this.timeCount = 0
						}
						console.log(_this.timeCount)
						_this.krpano = document.getElementById("krpanoSWFObject");
						_this.krpano.call("bottomMenuChangeScene(scene_" + _this.hallItem.sceneIds[_this.timeCount] + ")")
						_this.timeCount++
					}, 10000);



				}



			},
			bindMethod() {
				document.onmousedown = (e) => {
					document.onmousemove = (e) => { //鼠标按下并移动的事件
						// 鼠标拖拽时停止自动巡游

						// console.log(this.timer)
						if (this.timer) {
							console.log('停止巡游')
							clearInterval(this.timer);
							this.timer = null
						}

					};
					document.onmouseup = (e) => {
						if (!this.timer) {
							this.changeScene()
							console.log(this.timer)
							console.log('开始巡游')
						}

						// 鼠标抬起后等待十秒开启巡游
						document.onmousemove = null;
						document.onmouseup = null;
					};
				}


			},
			hideCover() {
				let timeout = 4000;
				let num = timeout / 1000;
				let interval = setInterval(() => {
					if (num == 0) {
						this.coverShow = false;

						clearInterval(interval);
					}
					this.countDown = num--;
				}, 1000);
			},
			weChatLogin() {
				let locationUrl = window.location.href;
				let appid = this.$global.WEICHAT_APPID;
				let state = "STATE"
				let redirectHref = this.$global.WEICHAT_URL +'?appid=' +
					appid + '&scope=snsapi_base' +
					// '&roomId='+this.$route.query.roomId+
					'&redirect_uri=' +
					encodeURIComponent(this.$global.SERVER_FRONT_WEB_URL) +
					'&response_type=code&scope=snsapi_userinfo'
				// '#wechat_redirect';
				// let redirectHref = 'http://sunshinebackend.natapp4.cc/data/common/get-weixin-code.html?appid=' +
				// 	appid + '&scope=snsapi_base' +
				// 	'&redirect_uri=' +
				// 	encodeURIComponent(locationUrl) +
				// 	'&response_type=code&scope=snsapi_userinfo&state=cloud'


				// let redirectHref = 'http://sunshinebackend.natapp4.cc/data/common/get-weixin-code.html?appid=' +
				// 	appid + '&scope=snsapi_base' +
				// 	'&redirect_uri=' +
				// 	encodeURIComponent(locationUrl) +
				// 	'&response_type=code&scope=snsapi_userinfo&state=cloud'

				// console.log(redirectHref)

				window.location.href = redirectHref;

			},
			wxRegCallback() {
				// 用于微信JS-SDK回调
				this.wxShareTimeline();
				this.wxShareAppMessage()
			},
			wxShareTimeline() {
				// let alumnus_name = sessionStorage.getItem('alumnus_name');
				// let alumnus_pic = sessionStorage.getItem('alumnus_pic')
				// 微信自定义分享到朋友圈
				let option = {
					title: this.hallItem.title, // 分享标题, 请自行替换
					desc: this.hallItem.describe, // 分享描述, 请自行替换
					link: window.location.href, // 分享链接，根据自身项目决定是否需要split
					imgUrl: this.hallItem.share, // 分享图标, 请自行替换，需要绝对路径
				};
				console.log(option)
				// 将配置注入通用方法
				wxapi.ShareTimeline(option)
			},
			wxShareAppMessage() {
				// let alumnus_name = sessionStorage.getItem('alumnus_name');
				// let alumnus_pic = sessionStorage.getItem('alumnus_pic')
				// 微信自定义分享给朋友

				let option = {
					title: this.hallItem.title, // 分享标题, 请自行替换
					desc: this.hallItem.describe, // 分享描述, 请自行替换
					link: window.location.href, // 分享链接，根据自身项目决定是否需要split
					imgUrl: this.hallItem.share, // 分享图标, 请自行替换，需要绝对路径
				}
				console.log(option)
				// 将配置注入通用方法
				wxapi.ShareAppMessage(option)
			},
		}
	};
</script>

<style lang="less">

</style>

<style lang="less" scoped>
	.content {
		width: 100%;
		height: 100%;
	}

	.views {
		color: #FFFFFF;
		font-size: 14px;
		z-index: 99;
		left: 25px;
		top: 75px;
		position: absolute;
	}

	#pano {
		width: 100%;
		height: 100%;
	}

	.photo-galley {
		display: none;
	}

	.marqueePC {
		// 滚动字幕,电脑端
		position: absolute;
		z-index: 99;
		width: 100%;
		left: 50%;
		transform: translateX(-50%);
		margin-bottom: 15px;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.marqueeMoblie {
		position: absolute;
		z-index: 1;
		width: 100%;
		left: 50%;
		transform: translateX(-50%);
		margin-bottom: 15px;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.cover {
		display: block;
		position: absolute;
		height: 100%;
		width: 100%;
		font-size: 0;
		z-index: 10000000;
		background-color: #dfebf1;


		.pc {
			--background: #fff;
			--filter: blur(80px);
			position: relative;
			width: 100%;
			height: 100%;
			color: #333;
			background-color: #000000;
			

			&:before {
				content: '';
				position: absolute;
				// top: -20%;
				width: 100%;
				height: 100%;
				// left: -20%;
				// width: 250vw;
				// height: 250vh;
				background: var(--background);
				// background-color: yellow;
				background-size: cover;
				transform: scale(1.5);
				filter: var(--filter);
				z-index: 0;
				background-size: cover;
			}

			.bg-image {
				position: absolute;
				object-fit: scale-down;
				// width: 1920px;
				// height: 1080px;

				// top: 0;
				// left: 0;
				// right: 0;
				// bottom: 0;
				top: 50%;
				left: 50%;
				// margin-left: -960px;
				// margin-top: -540px;
				transform: translateY(-50%);
				transform: translate(-50%, -50%);

				// background-size: cover;
				// background-postion: center center;
			}

			.enter-watch-button {
				position: absolute;
				margin: 0 auto;
				width: 100%;
				height: 50%;
				z-index: 90;
				bottom: 0;
				display: block;

			}


			.countdown-div {
				position: absolute;
				border: 1px solid #fff;
				border-radius: 25px;
				width: 60px;
				height: 30px;
				right: 20px;
				top: 50px;
				background-color: #00000025;

				span {
					display: block;
					width: 60px;
					height: 30px;
					font-size: 14px;
					color: #fff;
					text-align: center;
					line-height: 30px;
					cursor: pointer;
				}
			}


		}


		.moblie {
			--background: #fff;
			--filter: blur(80px);
			position: relative;
			width: 100%;
			height: 100%;
			color: #333;
			background-color: transparent;
			overflow: hidden;
			
			&:before {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				// top: -100px;
				// left: -100px;
				// width: 250vw;
				// height: 250vh;
				background: var(--background);
				background-size:cover;
				transform: scale(1.5);
				filter: var(--filter);
				z-index: 0;
				// background-size: cover;
			}
			
			img {
				display: block;
				position: relative;
				object-fit: scale-down;
				// width: 100%;
				// max-width: 640px;
				// height: auto;
				// margin-top: 0;
				margin: 0 auto;
			}

			.enter-watch-button {
				position: absolute;
				margin: 0 auto;
				width: 100%;
				height: 50%;
				z-index: 90;
				bottom: 0;
				display: block;
			}


			.countdown-div {
				position: absolute;
				border: 1px solid #fff;
				border-radius: 25px;
				width: 60px;
				height: 30px;
				right: 20px;
				top: 50px;
				background-color: #00000025;

				span {
					display: block;
					width: 60px;
					height: 30px;
					font-size: 14px;
					color: #fff;
					text-align: center;
					line-height: 30px;
					cursor: pointer;
				}
			}


		}

	}


	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.login {
		position: absolute;
		z-index: 100;
		display: flex;
	}
</style>
